module.exports = __webpack_public_path__ + "static/media/rocking-horse.579ddde9.svg";